import React from 'react'
import Retour from '../components/Retour'

function Piaffe() {
  return (
    <div>
         <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Eva, une jeune femme introvertie qui travaille comme bruiteuse, rencontre des difficultés pour créer les sons d’un film publicitaire mettant en vedette un cheval. Alors qu’une queue de cheval commence à pousser sur son corps, elle développe une relation de soumission avec un botaniste.</p>
    </div>
    <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
    </div>
    </div>
  )
}

export default Piaffe